// components/widgets/Stakeholders/BeliefScreen.jsx
import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

import PandaWave from "./PandaWave.jsx";
import defaultUser from "../../../../../assets/panda_stakeholders.png"; // replace with actual user avatar

const BeliefScreen = ({ data = {}, user: userProp, onNextStep }) => {
  const user = userProp || data?.user || {
    name: "You",
    avatar: defaultUser,
  };

  return (
    <div className="w-full h-full bg-black text-white flex flex-col overflow-y-auto pb-8">

{/* --------------------------------------------- */}
{/* TOP BAR — Pixel-Perfect MacOS Layout */}
{/* --------------------------------------------- */}
<div className="w-full bg-[#2B2B2B] px-4 flex items-center relative">

  {/* Left — Mac traffic lights */}
  <div className="flex items-center gap-2">
    <div className="w-3 h-3 rounded-full bg-[#FF5F57]" />
    <div className="w-3 h-3 rounded-full bg-[#FEBC2E]" />
    <div className="w-3 h-3 rounded-full bg-[#28C840]" />
  </div>

  {/* CENTER — Original Sound */}
  <div className="absolute left-1/2 -translate-x-1/2">
    <div className="flex items-center gap-2 bg-[#1E1E1E] border border-[#3A3A3A] px-3 py-[6px] rounded-md text-[#DADADA] text-sm cursor-pointer">
      Original Sound: Off
      <ChevronDown size={16} className="text-[#DADADA]" />
    </div>
  </div>

  {/* RIGHT — View button */}
  <div className="ml-auto">
    <button className="bg-[#1E1E1E] border border-[#3A3A3A] px-3 py-[6px] rounded-md text-[#DADADA] text-sm">
      View
    </button>
  </div>
</div>


      {/* --------------------------------------------- */}
      {/* VIDEO TILES */}
      {/* --------------------------------------------- */}
      <div className="w-full flex flex-row justify-center gap-8 px-6 mt-4">

        {/* LEFT TILE – Panda */}
        <div className="flex-1 bg-[#222] rounded-xl border border-[#3B9D94] p-6 h-[320px] relative">
          <div className="w-full h-full flex items-center justify-center">
            <PandaWave />
          </div>

          <div className="absolute bottom-4 left-4 bg-black/70 px-2 py-1 text-xs rounded text-white">
            Sto – Career Companion
          </div>
        </div>

        {/* RIGHT TILE – User */}
        <div className="flex-1 bg-[#222] rounded-xl border border-gray-700 p-6 h-[320px] relative">
          <div className="w-full h-full flex items-center justify-center">
            <div className="relative w-44 h-44 rounded-full border-[3px] border-gray-300 overflow-hidden">
              <img
                src={user.avatar || defaultUser}
                alt={user.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="absolute bottom-4 left-4 bg-black/70 px-2 py-1 text-xs rounded flex items-center gap-1 text-white">
            <span className="text-red-500">🎤</span>
            {user.name}
          </div>
        </div>
      </div>

      {/* --------------------------------------------- */}
      {/* TEXT SECTION */}
      {/* --------------------------------------------- */}
      <div className="text-center mt-10">
        <h2 className="text-3xl text-white">
          Let’s talk about how you are in meetings.
        </h2>
        <p className="text-gray-400 mt-2">
          I'll share my screen to share a few options with you.
        </p>
      </div>

      {/* --------------------------------------------- */}
      {/* BUTTON */}
      {/* --------------------------------------------- */}
      <div className="w-full flex justify-center mt-8">
        <motion.button
          whileTap={{ scale: 0.97 }}
          onClick={onNextStep}
          className="px-8 py-3 bg-[#5BC6B4] text-black font-medium rounded-full shadow-md flex items-center gap-2"
        >
          Start Meeting <span>➜</span>
        </motion.button>
      </div>

    </div>
  );
};

export default BeliefScreen;
